module.exports = __webpack_public_path__ + "static/media/company_unselected.6acb30b6.svg";